module.exports = __webpack_public_path__ + "static/media/good-sale-income.ed4130ab.svg";